//--------------------------------------------------------------------------------------------------
//# Imports

import React, { useEffect, useState } from 'react';
import Aos from "aos";
import "aos/dist/aos.css";

import './adminlinks.css'











//--------------------------------------------------------------------------------------------------
//# Variables

const delay_gap = 200;
let mobile = window.innerWidth <= 600;

//AppStart
const AdminLinks = () => {











//--------------------------------------------------------------------------------------------------
//# Functions

  //// This section and conditional HTML seems to fix the issue where animations wouldn't play, and seemed 
  //// to have already played and loaded before the user scrolled to them.
  // const [content_loaded, setcontent_loaded] = useState(false);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     // Simulate async data fetching
  //     await new Promise((resolve) => setTimeout(resolve, 1000));
  //     setcontent_loaded(true);
  //   };
  //   fetchData();
  // }, []);

  // useEffect(() => {
  //   if (content_loaded) {
  //     Aos.refresh(); // Refresh AOS after content is loaded
  //   }
  // }, [content_loaded]);
  //

  // Reset AOS timings after animation finishes so that mouseover animations are responsive
  useEffect(() => {
    Aos.init({ duration: 2000 });
    setTimeout(() => {
      }, 1000);  // Match to AOS duration
  }, []);

  








  function mouseOver(event) {
    
  };
  
  function mouseLeave(event) {
    
  };


  function handleClick(event) {
    console.log('\nAdminLinks.js >>> RUNNING handleClick()');
  };


  
    







//--------------------------------------------------------------------------------------------------
//# HTML

  return (
    <div className='adminLinks'>
      <div className='adminLinksLeftContainer'  id="anchorElement_AdminLinksLeftContainer">
        <div className='adminLinksTextContainer'>
          <div className='adminLinksText adminLinksTitle adminLinksTextTop'
            data-aos="fade-down" data-aos-delay={1 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              Admin Links</div>
          <div  className='adminLinksText'
            data-aos="fade-right" data-aos-delay={2 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://drive.google.com/drive/folders/1jMOLAStpjR4_Y9CvbDM_UQ_fjxKYgbok?usp=drive_link" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Google Drive</span></a></div>
          <div  className='adminLinksText'
            data-aos="fade-left" data-aos-delay={3 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://coda.io/d/_dCqYABCx2pK/Alchm-Progress_suhHR9wR" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Coda</span></a></div>
          <div  className='adminLinksText'
            data-aos="fade-right" data-aos-delay={4 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://github.com/EvanGottschalk/alchm" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Github</span> | Alchm Site Frontend</a></div>
          <div  className='adminLinksText'
            data-aos="fade-left" data-aos-delay={5 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://github.com/EvanGottschalk/alchm_backend" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Github</span> | Alchm Backend</a></div>
          <div  className='adminLinksText'
            data-aos="fade-right" data-aos-delay={6 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://account.squarespace.com/domains/managed/alchm.xyz" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Squarespace</span> | alchm.xyz Domain</a></div>
          <div  className='adminLinksText'
            data-aos="fade-left" data-aos-delay={7 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://vercel.com/evan-gottschalks-projects/alchm-frontend" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Vercel</span> | Site Frontend Hosting</a></div>
          <div  className='adminLinksText'
            data-aos="fade-right" data-aos-delay={8 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://dashboard.render.com/web/srv-csk6i2jtq21c73dj5hog" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Render</span> | Backend Hosting</a></div>
          <div  className='adminLinksText'
            data-aos="fade-left" data-aos-delay={9 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://dashboard.privy.io/apps/cmi9t84qs00acl80dam2j8195/users?tab=all-users" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Privy</span> | Account Authentication & Wallets</a></div>
          <div className='adminLinksText'
            data-aos="fade-right" data-aos-delay={10 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://cloud.mongodb.com/v2/69204d5406bc802c68c66048#/clusters" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>MongoDB</span> | Account & Avatar Database</a></div>
          <div className='adminLinksText'
            data-aos="fade-left" data-aos-delay={11 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://app.galileo.ai/alchm-ai/project/f9cf0af7-2d96-4f3b-85dd-d187315b6fea/log-streams/fd6501a7-8dcb-4f89-8bd1-39c163bbddcf?timeRange=%7B%22type%22%3A%22lastMonth%22%7D" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Galileo</span> | Alchmizer Logging</a></div>
          <div className='adminLinksText adminLinksTextBottom'
            data-aos="fade-right" data-aos-delay={12 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://app.gitbook.com/o/XdBfkTPqaOnFxDI5N5Ov/s/bWVa4Y2uziER1ZoG64Lg/" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Gitbook</span> | Alchm Docs</a></div>
        </div>
      </div>
      <div className='adminLinksRightContainer'  id="anchorElement_AdminLinksRightContainer">
        <div className='adminLinksTextContainer'>
          <div className='adminLinksText adminLinksTitle adminLinksTextTop'
            data-aos="fade-down" data-aos-delay={1 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              Public Links</div>
          <div  className='adminLinksText'
            data-aos="fade-right" data-aos-delay={2 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://forms.gle/6qcpMh5GSj1KwpeTA" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Early Access Form</span></a> |
              <a target="_blank" rel="noreferrer" href="https://docs.google.com/spreadsheets/d/1PMDABFSdcNldPVx4EzUFpgLFPRJAf0lKFQ0SP2I02pc/edit?usp=sharing" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}> Stats Sheet (internal)</span></a></div>
          <div  className='adminLinksText'
            data-aos="fade-left" data-aos-delay={3 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSfiD01ACmDxbXDPsoiG8wg9QCizZp3riaUfI4IaF1GnUpp2zA/viewform?usp=header" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Job Application Form</span></a> |
              <a target="_blank" rel="noreferrer" href="https://docs.google.com/spreadsheets/d/1P9FLeQ4yXOoXUOSszLA8cB2Yg024ud3vqZysKcAUAM0/edit?usp=sharing" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}> Stats Sheet (internal)</span></a></div>
          <div  className='adminLinksText'
            data-aos="fade-right" data-aos-delay={4 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://alchm.xyz" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>alchm.xyz</span></a></div>
          <div  className='adminLinksText'
            data-aos="fade-right" data-aos-delay={4 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="https://x.com/AlchmAI" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Twitter</span></a></div>
          <div  className='adminLinksText'
            data-aos="fade-left" data-aos-delay={5 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="http://instagram.com/alchmai" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>Instagram</span></a></div>
          <div className='adminLinksText adminLinksTextBottom'
            data-aos="fade-left" data-aos-delay={9 * delay_gap} data-aos-anchor-placement="top-center" data-aos-anchor="#anchorElement_AdminLinksRightContainer">
              • <a target="_blank" rel="noreferrer" href="http://docs.alchm.xyz/" className="adminLinksLink">
              <span style={{color: "var(--color-main)"}}>docs.alchm.xyz</span> | Public Docs</a></div>
        </div>
      </div>
    </div>
  )
}

export default AdminLinks
